<template>
  <div>
    <div v-if="issue.showUnknown" class="relative unknown-wrap" :style="{ paddingRight: wrapPaddingRight }">
      <div v-html="item.content.richText"></div>
      <div class="unknown-box relative">
        <el-radio v-model="item.selectUnknown" :label="true">
          <span>
            {{ issue.unknownText }}
          </span>
        </el-radio>
        <div v-if="disabled">
          <div class="absolute inset-0 z-10"></div>
        </div>
      </div>
    </div>
    <div v-else v-html="item.content.richText"></div>
    <div class="relative">
      <el-slider
        :class="{ disabled: item.selectUnknown }"
        v-model="item.value"
        :max="item.max"
        :min="item.min"
        :marks="marks"
        @change="item.selectUnknown = false"
        show-input
        ref="elSlider"
      />
      <div v-if="disabled">
        <div class="absolute inset-0 z-10"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TotalItem',
  props: {
    item: Object,
    issue: Object,
    disabled:Boolean
  },
  computed: {
    wrapPaddingRight() {
      return Math.max(this.issue.unknownText.length * 20, 40) + 'px'
    },
    marks() {
      const min = this.item.min
      const max = this.item.max
      let res = {
        [min]: min.toString(),
        [max]: max.toString()
      }
      if (!this.issue.showGraticule) return res
      const graticule = this.issue.graticule

      let step = (max - min) / graticule
      let val = min + step
      while (val < max) {
        const finalValue = Math.round(val)
        res[finalValue] = finalValue.toString()
        val += step
      }
      return res
    }
  },
  mounted() {
    if (this.issue.showUnknown) {
      this.uw = this.$watch(
        'item.selectUnknown',
        val => {
          const sliderEl = this.$refs.elSlider.$refs.slider
          if (val) {
            sliderEl.classList.add('disabled')
          } else {
            sliderEl.classList.remove('disabled')
          }
        },
        { immediate: true }
      )
    }
  },
  beforeDestroy() {
    this.uw && this.uw()
  }
}
</script>
